<template>
  <img
    class="logo"
    :src="logo"
    :alt="alt"
  />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'appLogo',
  computed: {
    ...mapState('tournament', ['logo', 'name']),
    alt() {
      return `${this.name} logo`
    }
  },
}
</script>

<style lang="scss" scoped>
.logo {
  display: block;
  max-width: 432px;
  margin: 0 auto;
}
</style>